// extracted by mini-css-extract-plugin
export var loadingShimmer = "_re-2";
export var messageContent = "_re-0";
export var messagesScroll = "_re-1";
export var shimmer = "_re-3";
export var shimmerW100 = "_re-4";
export var shimmerW70 = "_re-8";
export var shimmerW80 = "_re-7";
export var shimmerW85 = "_re-6";
export var shimmerW90 = "_re-5";